<div class="page-wrap">
    <div class="replace-matcard">
        <mat-card-header class="card-header">
            <div class="headerContainerLeft">
                <div class="headerContainerItem">
                    <mat-form-field class="w-350">
                        <mat-label>Choose a project</mat-label>
                        <mat-select [value]="selectedProjectID" (selectionChange)="changeProjectValue($event.value)">
                            <mat-option class="select-without-checkbox">{{projectDropdownTitle}}</mat-option>
                            <mat-option class="select-without-checkbox" *ngFor="let project of projects"
                                [value]="project.id">
                                {{project.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="headerContainerItem" *ngIf="anySelectedTrainHasSecondDeck">
                    <mat-form-field class="w-350">
                        <mat-label>{{luggageCalculationInputTitel}}</mat-label>
                        <mat-select [value]="2" (selectionChange)="changeLuggageCalculationInput($event.value)">
                            <mat-option class="select-without-checkbox"
                                *ngFor="let luggageCalculationInput of luggageCalculationInputSource"
                                [value]="luggageCalculationInput.Value">
                                {{luggageCalculationInput.Name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="headerContainerItem" style="margin-left: auto;">
                    <!-- <button mat-raised-button class="button color" (click)="debug()">Debug</button> -->
                    <button mat-raised-button class="button color" [disabled]="validateParameters()"
                        (click)="evaluate()">{{analyseButtonText}}</button>
                </div>
            </div>
            <div class="clearfix"></div>
        </mat-card-header>
        <mat-card-content class="card-content">
            <mat-tab-group>
                <mat-tab>
                    <ng-template mat-tab-label>{{tabTravelmixTitle}}</ng-template>
                    <app-evaluation-travel-mixes class="component-style"
                        [evaluationService]="evaluationService"></app-evaluation-travel-mixes>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{tabGraphicsTitle}}</ng-template>
                    <app-evaluation-graphics class="component-style"
                        *ngIf="evaluationService.companyGraphics?.length > 0; else notYetLoaded" [context]="'train'"
                        [evaluationService]="evaluationService"></app-evaluation-graphics>
                    <ng-template #notYetLoaded>
                        <p>Please select a project first to see this content</p>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{tabTrainsTitle}}</ng-template>
                    <div class="component-style">
                        <div class="overflow-auto mh-450" *ngIf="trainsAndDoorsForChecklist != null">
                            <div *ngFor="let train of trainsAndDoorsForChecklist;let i = index;">
                                <hr class="eval-item-line" *ngIf="i > 0">
                                <div class="item-container">
                                    <div>
                                        <span
                                            matTooltip="{{train.hasTrainConfiguration == true && train.hasDeletedVariants == true ? trainDeletedVariantsInfo : train.hasTrainConfiguration == false && train.hasDeletedVariants == false ? trainMissingConfigurationInfo : ''}}">
                                            <mat-checkbox [(ngModel)]="train.isSelected" class="checkbox-style"
                                                [disabled]="train.hasTrainConfiguration == true && train.hasDeletedVariants == true || train.hasTrainConfiguration == false && train.hasDeletedVariants == false"
                                                (ngModelChange)="loadDoors(train,$event);updateChild(train,$event)"
                                                value="train.id">
                                                <b>{{train.name}}</b>
                                            </mat-checkbox>
                                        </span>
                                    </div>
                                    <hr *ngIf="train.doors && passengerAlgorithmGraphicSelected">
                                    <h5 *ngIf="train.doors && passengerAlgorithmGraphicSelected">
                                        Door selection
                                    </h5>
                                    <div *ngIf="train.doors && passengerAlgorithmGraphicSelected">
                                        <mat-checkbox class="checkbox-style"
                                            (change)="setDoorsSelectedState(train,true,$event.checked)"
                                            [ngModel]="getCheckedState(train.doors,true)"
                                            [indeterminate]="getIntermediateState(train.doors,true)"
                                            [disabled]="!train.isSelected">
                                            Select all upper doors
                                        </mat-checkbox>
                                        <mat-checkbox class="checkbox-style"
                                            (change)="setDoorsSelectedState(train,false,$event.checked)"
                                            [ngModel]="getCheckedState(train.doors,false)"
                                            [indeterminate]="getIntermediateState(train.doors,false)"
                                            [disabled]="!train.isSelected">
                                            Select all lower doors
                                        </mat-checkbox>
                                    </div>
                                    <div *ngIf="train.doors && passengerAlgorithmGraphicSelected">
                                        <span *ngFor="let trainVariantDoor of train.doors"
                                            matTooltip="{{trainVariantDoor?.hasCollissions ? collidingObjectErrorInfo : ''}}">
                                            <mat-checkbox [(ngModel)]="trainVariantDoor.isSelected"
                                                class="checkbox-style" (ngModelChange)="syncTrainParamObject(train)"
                                                [disabled]="!train.isSelected"
                                                value="trainVariantDoor.identificationComponent.id">
                                                <span
                                                    [ngStyle]="{'color': trainVariantDoor?.hasCollissions ? 'red' : ''}">{{trainVariantDoor?.identificationComponent?.userId}}</span>
                                            </mat-checkbox>
                                        </span>
                                    </div>
                                    <hr
                                        *ngIf="train.acrossDeckAreaSelection?.length > 0 || train.separatDeckAreaSelection?.length > 0">
                                    <h5
                                        *ngIf="train.acrossDeckAreaSelection?.length > 0 || train.separatDeckAreaSelection?.length > 0">
                                        Area selection
                                    </h5>
                                    <div>
                                        <ng-container
                                            *ngIf=" considerAllDecksForCalculation && train.acrossDeckAreaSelection; else seperateDeckSelection">
                                            <span *ngFor="let selectableArea of train.acrossDeckAreaSelection">
                                                <mat-checkbox [(ngModel)]="selectableArea.isSelected"
                                                    class="checkbox-style" [disabled]="!train.isSelected"
                                                    value="selectableArea.name">
                                                    <span>{{selectableArea?.name}}</span>
                                                </mat-checkbox>
                                            </span>
                                        </ng-container>

                                        <ng-template #seperateDeckSelection>
                                            <span *ngFor="let selectableArea of train.separatDeckAreaSelection">
                                                <mat-checkbox [(ngModel)]="selectableArea.isSelected"
                                                    class="checkbox-style" (ngModelChange)="syncSelectableArea(train)"
                                                    [disabled]="!train.isSelected" value="selectableArea.name">
                                                    <span>{{selectableArea?.name}}</span>
                                                </mat-checkbox>
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            *ngIf="!trainsAndDoorsForChecklist && selectedProjectID ||  trainsAndDoorsForChecklist && trainsAndDoorsForChecklist.length == 0 && selectedProjectID then trainsUnavailable;">
                        </div>
                        <div *ngIf="!trainsAndDoorsForChecklist && !selectedProjectID; then projectUnavailable;">
                        </div>
                        <ng-template #trainsUnavailable>
                            <p>{{trainsUnavailableText}}</p>
                        </ng-template>
                        <ng-template #projectUnavailable>
                            <p>{{projectUnavailableText}}</p>
                        </ng-template>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{tabAdvancedSettingsTitle}}</ng-template>
                    <app-evaluation-advanced-settings [evaluationService]="evaluationService"
                        (onSaveAsProjectDefault)="loadProjects()"
                        class="component-style"></app-evaluation-advanced-settings>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </div>
</div>
<hr class="line">